import React from 'react'
import PropTypes from 'prop-types'
import { Alert, Button } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

import Loading from '../../../components/loading'

export function BusinessEditNoAccount() {
  const { t } = useTranslation()

  return (
    <div className="container mt-3">
      <Alert variant="warning">
        {t('business.edit.no_business_id', 'No business account found.')}
      </Alert>
    </div>
  )
}

export function BusinessEditLoadError({ error, onRetry }) {
  const { t } = useTranslation()

  return (
    <div className="container mt-3">
      <Alert variant="danger">
        {error}
        <div className="mt-2">
          <Button variant="primary" onClick={onRetry}>
            {t('business.edit.retry', 'Retry')}
          </Button>
        </div>
      </Alert>
    </div>
  )
}

export function BusinessEditInitialLoading() {
  return <Loading show />
}

BusinessEditLoadError.propTypes = {
  error: PropTypes.string,
  onRetry: PropTypes.func.isRequired,
}
